let elements = {
  mainImage: {
    imagePath: 'games/page023_game1/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  icons: {
    negative: 'games/page023_game1/img/t.png',
    positive: 'games/page023_game1/img/f.png',
  },
  withoutCheck: false,
  maxLength: 1,
  audio: {
    negative: 'games/page023_game1/audio/f.mp3',
    positive: 'games/page023_game1/audio/t.mp3',
  },
  pick: 9,
  pass: 3,
  questions: [
    {
      src: 'games/page023_game1/img/00.png',
      correct: 'ą',
      width: 200,
    },
    {
      src: 'games/page023_game1/img/01.png',
      correct: 'ę',
      width: 200,
    },
    {
      src: 'games/page023_game1/img/02.png',
      correct: 'ł',
      width: 200,
    },
    {
      src: 'games/page023_game1/img/03.png',
      correct: 'ć',
      width: 200,
    },
    {
      src: 'games/page023_game1/img/04.png',
      correct: 'ń',
      width: 200,
    },
    {
      src: 'games/page023_game1/img/05.png',
      correct: 'ó',
      width: 200,
    },
    {
      src: 'games/page023_game1/img/06.png',
      correct: 'ś',
      width: 200,
    },
    {
      src: 'games/page023_game1/img/07.png',
      correct: 'ź',
      width: 200,
    },
    {
      src: 'games/page023_game1/img/08.png',
      correct: 'ż',
      width: 200,
    },
  ],
};

export default elements;
